import {NsOffersLineOfferRes} from 'epic-graphql-types';

type VoucherWarning = Pick<NsOffersLineOfferRes, 'offerId' | 'namespace' | 'voucherNotApplyReason'>;

export enum CartActions {
	SET_VOUCHER_WARNINGS = 'SET_VOUCHER_WARNINGS',
	SET_CHECKOUT_ERROR = 'SET_CHECKOUT_ERROR',
	CLEAR_CHECKOUT_ERROR = 'CLEAR_CHECKOUT_ERROR'
}

export interface CartActionType<T, P> {
	type: T;
	payload: P;
}

interface SetVoucherWarningsPayload {
	lineOffers: (NsOffersLineOfferRes | null)[];
}

export type CartAction =
	| CartActionType<CartActions.SET_VOUCHER_WARNINGS, SetVoucherWarningsPayload>
	| CartActionType<CartActions.SET_CHECKOUT_ERROR, {error: Error | string}>
	| {type: CartActions.CLEAR_CHECKOUT_ERROR};

export type CartState = {
	voucherWarnings: VoucherWarning[];
	checkoutError: Error | string | undefined;
};

export interface CartContextState {
	cartState: CartState;
	dispatch: (action: CartAction) => void;
}
